export default __webpack_public_path__ + "static/media/AuctionFinish.b051e2b0.png";